import * as React from "react";
import { useSelector } from 'react-redux';
import {
    Input,
    Menu,
    Navbar,
    Button,
    IconButton,
} from "@material-tailwind/react";

import {
    User,
    NavArrowDown,
    Bell,
    Search,
    UserCircle,
    Settings,
    HeadsetHelp,
    LogOut,
} from "iconoir-react";

import { RootState } from "../redux";

interface DashboardNavbarProps {
}


const DashboardNavbar: React.FC<DashboardNavbarProps> = () => {
    const { auth } = useSelector((state: RootState) => state.auth);

    return (
        <Navbar variant="ghost" className="bg-white overflow-visible">
            <div className="flex items-center relative px-2 md:px-4 py-1">
                <div className="flex grow flex-col-reverse md:flex-row items-center gap-4 md:ml-auto">
                    <Input placeholder="Search..." className="">
                        <Input.Icon placement="end">
                            <Search className="h-full w-full" />
                        </Input.Icon>
                    </Input>

                    <div className="flex items-center gap-4 ml-auto">
                        <IconButton isCircular variant="ghost" color="secondary" className="grid">
                            <Bell className="w-5 h-5 " />
                        </IconButton>

                        <Menu>
                            <Menu.Trigger
                                as={IconButton}
                                variant="ghost"
                                className="w-[70px] flex gap-2 items-center hover:bg-gray-100"
                            >
                                {auth?.user?.avatar ? (
                                    <div className="flex items-center justify-center w-7 h-7 bg-gray-200 rounded-full">
                                        <img src={auth?.user?.avatar} className="h-5 w-5" />
                                    </div>
                                ) : (
                                    <div className="flex items-center justify-center w-7 h-7 bg-gray-200 rounded-full">
                                        <User className="h-5 w-5" />
                                    </div>
                                )}
                                <NavArrowDown className="h-5 w-5 stroke-2" />
                            </Menu.Trigger>
                            <Menu.Content>
                                <Menu.Item>
                                    <UserCircle className="mr-2 h-[18px] w-[18px]" /> My Profile
                                </Menu.Item>
                                <Menu.Item>
                                    <Settings className="mr-2 h-[18px] w-[18px]" /> Edit Profile
                                </Menu.Item>
                                <Menu.Item>
                                    <HeadsetHelp className="mr-2 h-[18px] w-[18px]" /> Support
                                </Menu.Item>
                                <hr className="!my-1 -mx-1 border-surface" />
                                <Menu.Item className="text-error hover:bg-error/10 hover:text-error focus:bg-error/10 focus:text-error dark:hover:text-error dark:focus:text-error">
                                    <LogOut className="mr-2 h-[18px] w-[18px]" />
                                    Logout
                                </Menu.Item>
                            </Menu.Content>
                        </Menu>

                        <Button className="overflow-hidden px-10">SUPPORT</Button>
                    </div>
                </div>
            </div>
        </Navbar>
    );
};

export default DashboardNavbar;
